import { render, staticRenderFns } from "./xmFooter.vue?vue&type=template&id=7b015b19&scoped=true&"
import script from "./xmFooter.vue?vue&type=script&lang=js&"
export * from "./xmFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b015b19",
  null
  
)

export default component.exports